<template>
  <div>
    <CreateLab v-model="showCreateDialog" @created="handleLabCreated" />
    <EditLab v-model="showEditDialog" :lab="selectedLab" @updated="handleLabUpdated" />
    <DeleteLab v-model="showDeleteDialog" :lab="selectedLab" @deleted="handleLabDeleted" />

    <div class="table-container">
      <v-card flat>
        <v-data-table :headers="headers" :items="labs" :items-per-page="50" :loading="tableLoading"
          class="elevation-0 custom-data-table" :no-data-text="noDataText" :height="tableHeight" fixed-header
          density="compact">
          <template v-slot:top>
            <div class="d-flex justify-space-between align-center pa-4">
              <span class="text-h5">Labs</span>
              <v-btn color="primary" prepend-icon="mdi-plus" @click="handleCreateLab">
                Create Lab
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.created_on`]="{ item }">
            {{ formatDate(item.created_on) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-menu location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn icon size="small" variant="text" v-bind="props" @click.stop>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item title="Edit" @click.stop="handleEdit(item)">
                  <template v-slot:prepend>
                    <v-icon color="primary" size="small">mdi-pencil</v-icon>
                  </template>
                </v-list-item>
                <v-list-item title="Delete" @click.stop="handleDelete(item)">
                  <template v-slot:prepend>
                    <v-icon color="error" size="small">mdi-delete</v-icon>
                  </template>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import CreateLab from "@/components/Labs/Diloag/CreateLab.vue";
import EditLab from "@/components/Labs/Diloag/EditLab.vue";
import DeleteLab from "@/components/Labs/Diloag/DeleteLab.vue";
import GetLabsList from "@/mixins/Labs/GetLabsList";
export default {
  name: "LabsPage",
  components: {
    CreateLab,
    EditLab,
    DeleteLab,
  },
  mixins: [GetLabsList],
  data() {
    return {
      windowHeight: window.innerHeight,
      showCreateDialog: false,
      showEditDialog: false,
      showDeleteDialog: false,
      tableLoading: false,
      selectedLab: null,
      labs: [],
      headers: [
        { title: "Lab Name", key: "lab_name", sortable: true },
        { title: "Created By", key: "created_by", sortable: true },
        { title: "Created On", key: "created_on", sortable: true },
        { title: "Actions", key: "actions", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    noDataText() {
      return "No labs found.";
    },
    tableHeight() {
      return this.windowHeight - 170;
    },
  },
  async mounted() {
    this.updateWindowHeight();
    window.addEventListener("resize", this.updateWindowHeight);

    this.tableLoading = true;

    try {
      await this.fetchLabsList();
      this.labs = this.labsList;
    } catch (error) {
      console.error("Error loading labs:", error);
    } finally {
      this.tableLoading = false;
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateWindowHeight);
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return "-";

      return new Date(Number(timestamp)).toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
    },
    async refreshLabs() {
      this.tableLoading = true;

      try {
        await this.fetchLabsList();
        this.labs = this.labsList;
      } catch (error) {
        console.error("Error loading labs:", error);
      } finally {
        this.tableLoading = false;
      }
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight;
    },
    handleCreateLab() {
      this.showCreateDialog = true;
    },
    handleEdit(item) {
      this.selectedLab = { ...item };
      this.showEditDialog = true;
    },
    handleDelete(item) {
      this.selectedLab = { ...item };
      this.showDeleteDialog = true;
    },
    async handleLabCreated() {
      await this.refreshLabs();
    },

    async handleLabUpdated() {
      await this.refreshLabs();
      this.selectedLab = null;
    },

    async handleLabDeleted() {
      await this.refreshLabs();
      this.selectedLab = null;
    },
  },
};
</script>
